import { useVariables } from "../context/VariableContext";

export const useVariable = (name) => {
  const { variables } = useVariables();
  return variables[name];
};